export default __webpack_public_path__ + "static/media/XD_ico.9c40f0ce.svg";